import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import EditInfoModal from '../../EditInfoModal';

interface IProps {
  currentName: string;
  snapshotName?: string;
  currentDescription: string;
  onChangeInfo: (newName: string, newDescription: string) => void;
  closeWindow: () => void;
}

export default ({
  currentName,
  snapshotName,
  currentDescription,
  onChangeInfo,
  closeWindow,
}: IProps) => {
  const workspaceList = useAppSelector(
    (state) => state.workspaces.workspaceList,
  );

  return (
    <EditInfoModal
      entity="workspace"
      name={currentName}
      snapshotName={snapshotName}
      description={currentDescription}
      onClose={closeWindow}
      onSubmit={onChangeInfo}
      entitiesList={workspaceList}
      trackContext="workspaces"
      trackSubmitAction="edit info - update"
      trackCancelAction="edit info - cancel"
    />
  );
};
